document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('helpSearch');
  const searchButton = document.getElementById('searchSubmit');
  const searchResults = document.getElementById('searchResults');

  if (!searchInput || !searchButton || !searchResults) return;

  const articles = [
    {
      title: 'Hvor finner jeg IMEI-nummeret?',
      text: 'Finn IMEI-nummeret til Lildog-enheten din.',
      url: '/pages/lildog-appen',
      keywords: ['imei', 'imei nummer', 'imei-nummer', 'nummer', 'enhet']
    },
    {
      title: 'Hvordan kommer jeg i gang med Lildog?',
      text: 'Kom i gang med Lildog – fra lading til tilkobling og aktivering.',
      url: '/pages/kom-i-gang',
      keywords: ['kom i gang', 'oppstart', 'starte', 'aktivere', 'aktivering', 'koble til', 'lading']
    },
    {
      title: 'Lildog-enheten – lys, lyd og batteri',
      text: 'Finn hjelp med lys- og lydsignaler, batteritid, vanntetthet og Lildog-enheten.',
      url: '/pages/lildog-enheten',
      keywords: ['lys', 'lyd', 'lydsignal', 'lyssignal', 'batteri', 'batteritid', 'lading', 'vanntett', 'vanntetthet', 'enhet']
    },
    {
      title: 'Hjelp med Lildog-appen',
      text: 'Finn hjelp med appen, sporing, kart, konto og administrering av kjæledyr.',
      url: '/pages/lildog-appen',
      keywords: ['app', 'appen', 'sporing', 'live', 'sanntid', 'kart', 'karttype', 'konto', 'passord', 'kjæledyr', 'telefon']
    },
    {
      title: 'Abonnement og betaling',
      text: 'Finn hjelp med abonnement, betaling, abonnementsnivå og overføring til ny enhet.',
      url: '/pages/abonnement-hjelp',
      keywords: ['abonnement', 'betaling', 'betalingsmåte', 'premium', 'basic', 'familie', 'oppgradere', 'nedgradere', 'overføre abonnement', 'ny enhet']
    },
    {
      title: 'Levering og retur',
      text: 'Finn informasjon om levering, retur, returetikett, åpent kjøp og refusjon.',
      url: '/pages/levering-og-retur',
      keywords: ['levering', 'retur', 'returetikett', 'åpent kjøp', 'refusjon', 'pakke', 'emballasje', 'ordre']
    },
    {
      title: 'Kontakt kundeservice',
      text: 'Få hjelp fra kundeservice dersom du ikke finner svaret du leter etter.',
      url: '/pages/kontakt-kundeservice',
      keywords: ['kontakt', 'kundeservice', 'hjelp', 'support', 'henvendelse', 'kontakte', 'spørsmål']
    }
  ];

  function closeSearch() {
    searchResults.innerHTML = '';
    searchResults.classList.remove('is-open');
  }

  function runSearch() {
    const query = searchInput.value.trim().toLowerCase();

    if (!query) {
      closeSearch();
      return;
    }

    const matches = articles.filter(function (article) {
      return (
        article.title.toLowerCase().includes(query) ||
        article.text.toLowerCase().includes(query) ||
        article.keywords.some(function (keyword) {
          return keyword.includes(query) || query.includes(keyword);
        })
      );
    });

    if (matches.length === 0) {
      searchResults.innerHTML =
        '<div class="search__result"><span class="search__result-title">Ingen treff</span><span class="search__result-snippet">Prøv et annet søkeord.</span></div>';

      searchResults.classList.add('is-open');
      return;
    }

    searchResults.innerHTML = matches.map(function (article) {
      return (
        '<a class="search__result" href="' + article.url + '">' +
          '<span class="search__result-title">' + article.title + '</span>' +
          '<span class="search__result-snippet">' + article.text + '</span>' +
        '</a>'
      );
    }).join('');

    searchResults.classList.add('is-open');
  }

  /* LIVE-SØK MENS MAN SKRIVER */
  searchInput.addEventListener('input', runSearch);

  /* Enter fungerer fortsatt */
  searchInput.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      runSearch();
    }

    if (event.key === 'Escape') {
      closeSearch();
      searchInput.blur();
    }
  });

  /* Søk-knappen fungerer fortsatt */
  searchButton.addEventListener('click', runSearch);

  /* Lukk resultatlisten når man klikker utenfor søket */
  document.addEventListener('click', function (event) {
    if (
      !searchInput.contains(event.target) &&
      !searchResults.contains(event.target) &&
      !searchButton.contains(event.target)
    ) {
      closeSearch();
    }
  });
});